import React from 'react';
import { cn } from './cn';

const VARIANTS = {
  neutral: 'bg-ink-100 text-ink-700 dark:bg-ink-700 dark:text-ink-200',
  brand: 'bg-brand-100 text-brand-700 dark:bg-brand-500/15 dark:text-brand-300',
  success: 'bg-success-100 text-success-700 dark:bg-success-500/15 dark:text-success-500',
  warning: 'bg-warning-100 text-warning-700 dark:bg-warning-500/15 dark:text-warning-500',
  danger: 'bg-danger-100 text-danger-700 dark:bg-danger-500/15 dark:text-danger-500',
  info: 'bg-info-100 text-info-700 dark:bg-info-500/15 dark:text-info-500',
  mono: 'bg-ink-100 text-ink-700 font-mono dark:bg-ink-700 dark:text-ink-200',
};

const SIZES = {
  sm: 'h-[18px] px-1.5 text-[10px] leading-none',
  md: 'h-5 px-2 text-caption',
};

/**
 * Badge — compact label for counts / keys / short tags.
 *   variant: neutral | brand | success | warning | danger | info | mono
 *   size: sm | md (default)
 *   dot: adds leading status dot (matches variant)
 */
export function Badge({ variant = 'neutral', size = 'md', dot, className, children }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full font-medium whitespace-nowrap',
        SIZES[size],
        VARIANTS[variant],
        className,
      )}
    >
      {dot && (
        <span
          aria-hidden
          className={cn(
            'h-1.5 w-1.5 rounded-full',
            variant === 'neutral' && 'bg-ink-500',
            variant === 'brand' && 'bg-brand-600',
            variant === 'success' && 'bg-success-600',
            variant === 'warning' && 'bg-warning-600',
            variant === 'danger' && 'bg-danger-600',
            variant === 'info' && 'bg-info-600',
            variant === 'mono' && 'bg-ink-500',
          )}
        />
      )}
      {children}
    </span>
  );
}

export default Badge;
